export const events = {
    state: {
        emailEvents: [],
    },
    reducers: {
        setEmailEvents: (state, events) => ({
            emailEvents: events,
        }),
        clearEmailEvents: (state) => ({
            emailEvents: [],
        })
    }
};
